import { useSSRQuery } from './useSSRQuery';

const useTranslationsQuery = query => {
  const { loading, error, data } = useSSRQuery(query);

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  return data?.application.translations;
};

export default useTranslationsQuery;
